import { fetchApi } from '@/config/axiosSetting';
import {
  GetCulpritAdjusterImageTabsAlertsQueryParamType,
  GetCulpritAdjusterImageTabsAlertsQueryResponseQueryType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritAdjusterImageTabsAlerts/getCulpritAdjusterImageTabsAlertsQuery.type';

export const getCulpritAdjusterImageTabsAlertsQueryFunctions = (
  params: GetCulpritAdjusterImageTabsAlertsQueryParamType,
): Promise<GetCulpritAdjusterImageTabsAlertsQueryResponseQueryType> =>
  fetchApi.get(
    `property/reports/${params.id}/accident_users/culprit/images/entry_tabs/alerts/`,
  );
